import * as React from "react";
import { forwardRef } from "react";
const SvgExclamationMark = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.5 13.5V14.5H7.5V13.5H8.5ZM8.5 1.5V10.5H7.5V1.5H8.5Z", stroke: "currentColor" }));
const ForwardRef = forwardRef(SvgExclamationMark);
export default ForwardRef;
